<template>
  <div>
    
    <div v-if="!file">
      <div
        :class="['dropZone', dragging ? 'dropZone-over' : '']"
        @dragenter="dragging = true"
        @dragleave="dragging = false"
      >
        <div class="dropZone-info" @drag="onChange">
          <span class="fa fa-cloud-upload dropZone-title"></span>
          <span class="dropZone-title">{{$t('upload.instr1')}}</span>
          <div class="dropZone-upload-limit-info">
            <div>{{$t('upload.info1')}} {{mimeTypesSupported}}</div>
            <div>{{$t('upload.info2')}} {{fileSizeMax}}</div>
          </div>
        </div>
        <input type="file" @change="onChange" />
      </div>
    </div>
    <div v-else class="dropZone-uploaded">
      <div class="dropZone-uploaded-info">
        <span class="dropZone-title">{{$t('upload.afterSend')}}</span>
        <button
          type="button"
          class="btn btn-primary removeFile"
          @click="removeFile"
        >
          {{$t('upload.afterSendOption')}}
        </button>
      </div>
    </div>

    <div class="uploadedFile-info">
      <div>{{$t('upload.info3')}} {{ file.name }}</div>
      <div>{{$t('upload.info4')}} {{ file.size }}</div>
      <div>{{$t('upload.info5')}} {{ extension }}</div>
    </div>
  </div>
</template>
<style>
.dropZone {
  width: 100%;
  height: 150px;
  position: relative;
  border: 2px dashed #eee;
  transition-duration: 0.5s;
}

.dropZone:hover {
  border: 2px dashed #e754a2;
}

.dropZone:hover .dropZone-title {
  color: #645769;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 150px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
</style>

<script>
import Swal from "sweetalert2";

export default {
  props: {
    mimeTypes:Array, 
    mimeTypesSupported: String,
    mimeError: String,
    fileSizeMaxBytes: Number,
    fileSizeMaxError: String,
    fileSizeMax: String,
  },

  data: () => ({
    file: "",
    dragging: false,
  }),
  methods: {
    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.dragging = false;
        return;
      }
      this.createFile(files[0]);
    },
    
    createFile(file) {
      if (!this.mimeTypes.includes(file.type)) {
        Swal.fire({
          title: "Format non autorisé",
          text: this.mimeError,
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
        this.dragging = false;
        return;
      }

      if (file.size > this.fileSizeMaxBytes) {
        Swal.fire({
          title: "Fichier trop volumineux",
          text: this.fileSizeMaxError,
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
        this.dragging = false;
        return;
      }

      this.file = file;
      this.dragging = false;
      this.$emit('updateFile', file) 
    },
    removeFile() {
      this.file = "";
    },
  },
  computed: {
    extension() {
      return this.file ? this.file.name.split(".").pop() : "";
    },
  },
};
</script>
